import { html } from "../../../../../jb-nexus/node_modules/lit";
import { NexusComponent } from "../modules/nexus.component";

export class ButtonWithDropdown extends NexusComponent {
  static properties = {
    open: { type: Boolean, reflect: true },
    color: { type: String },
    buttonText: { type: String, attribute: "button-text" },
    classes: { type: String }
  };

  constructor() {
    super();
    this.open = false;
    this.color = "primary";
    this.classes = "";
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.classes = this.className || "";
    this.addEventListener("click", this.handleToggle);
    document.addEventListener("click", this.handleOutsideClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleToggle = (event) => {
    if (event.target.closest("button")) {
      event.preventDefault();
      event.stopPropagation();
      this.open = !this.open;
    }
  };

  handleOutsideClick = (event) => {
    if (!this.contains(event.target)) {
      this.open = false;
    }
  };

  firstUpdated() {
    this.moveSlottedContent();
  }

  updated() {
    this.moveSlottedContent();
  }

  moveSlottedContent() {
    const dropdownMenu = this.querySelector(".button-dropdown-menu");
    const existingContent = this.querySelector("ul, ol");

    if (dropdownMenu && existingContent && !dropdownMenu.contains(existingContent)) {
      dropdownMenu.appendChild(existingContent);
    }
  }

  render() {
    return html`
      <button class="btn btn-${this.color} ${this.classes}" type="button">
        ${this.buttonText}
        <svg class="button-dropdown-arrow ${this.open ? 'open' : ''}" viewBox="0 0 20 20"  xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.90999 5.3125L1.5625 6.6805L9.16977 14.404C9.34845 14.5854 9.59098 14.6875 9.84375 14.6875C10.0963 14.6875 10.3388 14.5854 10.5175 14.404L18.125 6.6805L16.7775 5.3125L9.84375 12.3518L2.90999 5.3125Z" />
        </svg>
      </button>

      <div class="button-dropdown-menu ${this.open ? "show" : ""}"></div>
    `;
  }
}

customElements.define("button-with-dropdown", ButtonWithDropdown);
